<template>
  <delete-confirm
      domain="스토리"
      @delete-domain="deleteStory"
  >
    <v-checkbox
        dense
        color="primary"
        hide-details
        v-model="doNotShowStoryDeleteConfirmModal"
        style="color: rgba(158, 158, 158, 1)"
        label="다음부터 표시하지 않기"
    />
  </delete-confirm>
</template>

<script>

import DeleteConfirm from "@/components/Common/DeleteConfirm";
import behavior from "@/constants/behavior";

export default {
  name: 'StoryDeleteConfirm',
  components: {
    'delete-confirm': DeleteConfirm
  },
  data: () => ({
    doNotShowStoryDeleteConfirmModal: false,
  }),
  methods: {
    deleteStory() {
      this.$emit('deleteStory')
      this.$store.commit(behavior.SET_DO_NOT_SHOW_STORY_DELETE_CONFIRM_MODAL, this.doNotShowStoryDeleteConfirmModal)
    },
  }
}
</script>

<style scoped>

</style>